export interface NetworkRetryPolicy {
  readonly retries: number;
  readonly delayMs: (retryNumber: number) => number;
  readonly shouldRetryResponse?: (response: Response) => boolean;
}

const linearDelay = (retryNumber: number) => 300 * retryNumber;

export const TRANSIENT_READ_RETRY: NetworkRetryPolicy = Object.freeze({
  retries: 1,
  delayMs: linearDelay,
});

export const AUTH_STATE_READ_RETRY: NetworkRetryPolicy = Object.freeze({
  retries: 1,
  delayMs: linearDelay,
  shouldRetryResponse: (response: Response) => response.status >= 500 && response.status <= 599,
});

export const IDEMPOTENT_WRITE_RETRY: NetworkRetryPolicy = Object.freeze({
  retries: 1,
  delayMs: linearDelay,
});

export const NO_RETRY: NetworkRetryPolicy = Object.freeze({
  retries: 0,
  delayMs: () => 0,
});
